import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { SegmentService } from 'ngx-segment-analytics';
import { TrackingSegmentService } from '@unico-people/shared/data-access-tracking-segment';

import { SegmentNameEnum, SegmentTitlePage } from '@unico-people/ongoing';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Component({
  selector: 'unico-people-web-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private listIgnore = ['callback', 'preauthorize'];
  private name: string;
  private properties: any;

  constructor(private router: Router, private trackingService: TrackingSegmentService,  private elementRef: ElementRef) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.listIgnore.some(url => event.urlAfterRedirects.includes(url))) {
          this.mountPage(event.urlAfterRedirects);
          if (this.name && this.properties?.title) {
            this.trackingService.page(this.name, this.properties);
          }
        }
      }
    });
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.removeAttribute('ng-version');
  }

  mountPage(url: string): void {
    const hasProfileUrl = !!url.match(/profile/g);
    const hasSignaturesUrl = !!url.match(/signatures/g);
    const path = hasProfileUrl? hasSignaturesUrl ? '/signatures' : '/profile' : url;

    this.name = SegmentNameEnum[path];
    this.properties = {
      account: SessionStorage.getItem('currentAccountName'),
      organization: SessionStorage.getItem('organizationName'),
      title: SegmentTitlePage[path],
      url: window.location.origin + url
    };
  }
}
